@if (
    $any(firstLevel?.[$any(elementDefinition?.name)]);
    as FIRST_LEVEL_ELEMENT
) {
    <ng-container [formGroup]="$any(controlContainer.control)">
        <wdx-ff-sub-form-header
            [amount]="FIRST_LEVEL_ELEMENT.formArray.controls.length"
            [elementDefinition]="$any(elementDefinition)"
            [disabled]="disabled"
            [showValidation]="validationStatus"
            [readonlyMode]="readonlyMode"
            (addToArray)="
                addToArray(
                    elementDefinition,
                    false,
                    FIRST_LEVEL_ELEMENT.formArray.controls.length
                )
            "
        ></wdx-ff-sub-form-header>
        <hr />

        @if (firstLevel) {
            <div
                ngbAccordion
                #accordionSubFrom
                class="accordion sub-form-accordion d-block"
                [closeOthers]="false"
                [destroyOnHide]="false"
                (hide)="panelChange($event, true)"
                (show)="panelChange($event, false)"
            >
                @for (
                    childForm of FIRST_LEVEL_ELEMENT.formArray.controls;
                    track $index;
                    let childFormIndex = $index, first = $first
                ) {
                    @if (
                        FIRST_LEVEL_ELEMENT?.pendingChanges;
                        as PENDING_CHANGES
                    ) {
                        <div
                            [ngbAccordionItem]="
                                'ngb-panel-' +
                                elementDefinition.name +
                                '-child-' +
                                childFormIndex
                            "
                            tabindex="0"
                            [attr.data-cy]="
                                elementDefinition.name + '-' + childFormIndex
                            "
                            [class.danger]="PENDING_CHANGES[childFormIndex]"
                            class="card-muted sub-form"
                        >
                            <div ngbAccordionHeader aria-level="3">
                                <button
                                    ngbAccordionButton
                                    #panelToggle
                                    type="button"
                                    class="accordion-header accordion-button w-100 bg-muted"
                                    data-cy="organism-reactive-accordion-header"
                                    [attr.aria-label]="
                                        'A11Y_ACCORDION_TOGGLE'
                                            | translateTokenisedString
                                    "
                                >
                                    <wdx-ff-accordion-header
                                        class="flex-grow-1"
                                        [entityId]="entityId"
                                        [place]="childFormIndex"
                                        [elementDefinition]="
                                            $any(elementDefinition)
                                        "
                                        [parentData]="parentData"
                                        [formControlObj]="childForm"
                                        [panelInfo]="openPanels"
                                        [hasError]="
                                            !!validationSummary[childFormIndex]
                                        "
                                        [disabled]="disabled"
                                        [status]="
                                            PENDING_CHANGES[childFormIndex]
                                                ?.action
                                        "
                                        [readonlyMode]="readonlyMode"
                                        (removeItem)="
                                            removeFromArray(
                                                elementDefinition,
                                                childFormIndex
                                            )
                                        "
                                        (cloneItem)="
                                            cloneItem(
                                                elementDefinition,
                                                childForm
                                            )
                                        "
                                    ></wdx-ff-accordion-header>
                                </button>
                            </div>

                            <div ngbAccordionCollapse>
                                <div ngbAccordionBody>
                                    <wdx-ff-sub-form-content
                                        #subForm
                                        class="d-block"
                                        [formGroupName]="childFormIndex"
                                        [attr.data-cy]="
                                            elementDefinition.name +
                                            '-' +
                                            childFormIndex
                                        "
                                    >
                                        @if (
                                            validationSummary[childFormIndex];
                                            as validationSummary
                                        ) {
                                            <div class="g-col-12">
                                                @if (
                                                    $any(
                                                        validationSummary
                                                            ?.errors?.length
                                                    ) > 0
                                                ) {
                                                    <wdx-ff-validation-summary
                                                        [message]="
                                                            VALIDATION_SUMMARY_MESSAGE
                                                        "
                                                        [validationSummary]="
                                                            validationSummary
                                                        "
                                                        (errorClicked)="
                                                            onErrorClicked(
                                                                $event,
                                                                childFormIndex
                                                            )
                                                        "
                                                    ></wdx-ff-validation-summary>
                                                }
                                            </div>
                                        }

                                        @for (
                                            childElement of $any(
                                                elementDefinition.children?.[0]
                                                    ?.layoutAndDefinition?.[
                                                    childFormIndex
                                                ]
                                            );
                                            track childElement.name;
                                            let childElementIndex = $index
                                        ) {
                                            @if (
                                                !childElement.isHidden &&
                                                (childElement.elementType ||
                                                    childElement.fieldType)
                                            ) {
                                                @if (
                                                    childElement.forcesNewRow &&
                                                    !childElement.forcesFullWidth
                                                ) {
                                                    <div class="g-col-12"></div>
                                                }

                                                <div
                                                    class="g-col-12 input form-input mb-1"
                                                    [attr.data-cy]="
                                                        'lbl-' +
                                                        childElement.name
                                                    "
                                                    [attr.data-form-control]="
                                                        childElement.name
                                                    "
                                                    [attr.data-form-control-level]="'child'"
                                                    [class.g-col-lg-6]="
                                                        !childElement.forcesFullWidth &&
                                                        childElement.fieldType !==
                                                            FormFieldType.Address &&
                                                        (!childElement.forcesNewRow ||
                                                            !childElement.forcesFullWidth)
                                                    "
                                                >
                                                    @if (
                                                        childElement.fieldType !==
                                                        FormFieldType.Array
                                                    ) {
                                                        <wdx-ff-controls-container
                                                            class="h-100"
                                                            [entityId]="
                                                                entityId
                                                            "
                                                            [formElement]="
                                                                $any(
                                                                    childElement
                                                                        | spread
                                                                            : {
                                                                                  parentName:
                                                                                      elementDefinition.name,
                                                                                  index: childFormIndex,
                                                                              }
                                                                )
                                                            "
                                                            [formContext]="
                                                                formContext
                                                            "
                                                            (formEvent)="
                                                                formEvent.emit(
                                                                    $event
                                                                )
                                                            "
                                                            [attr.data-cy]="
                                                                'child-element-' +
                                                                childElement.name
                                                            "
                                                        ></wdx-ff-controls-container>
                                                    }
                                                </div>

                                                @if (
                                                    childElement.fieldType ===
                                                    'Array'
                                                ) {
                                                    <div
                                                        class="g-col-12 input form-input mb-3"
                                                        [formArrayName]="
                                                            childElement.name
                                                        "
                                                    >
                                                        @if (
                                                            childElement
                                                                ?.children[0]
                                                                ?.section
                                                                ?.guidanceText
                                                        ) {
                                                            <div
                                                                class="form-section__body__blurb sub-3"
                                                            >
                                                                {{
                                                                    childElement
                                                                        ?.children[0]
                                                                        ?.section
                                                                        ?.guidanceText
                                                                }}
                                                            </div>
                                                        }
                                                        <wdx-ff-sub-form-header
                                                            [amount]="
                                                                firstLevel[
                                                                    $any(
                                                                        elementDefinition.name
                                                                    )
                                                                ].formArray
                                                                    .controls[
                                                                    childFormIndex
                                                                ].controls[
                                                                    childElement
                                                                        .name
                                                                ].controls
                                                                    .length
                                                            "
                                                            [elementDefinition]="
                                                                childElement
                                                            "
                                                            (addToArray)="
                                                                formArrayService?.addToArray(
                                                                    childElement,
                                                                    {
                                                                        useFormData: false,
                                                                        parentLayoutAndDef:
                                                                            $any(
                                                                                elementDefinition
                                                                            ),
                                                                        parentIndex:
                                                                            childFormIndex,
                                                                    }
                                                                )
                                                            "
                                                        ></wdx-ff-sub-form-header>

                                                        <div
                                                            ngbAccordion
                                                            class="accordion sub-form-accordion d-block"
                                                            [closeOthers]="
                                                                false
                                                            "
                                                            [destroyOnHide]="
                                                                false
                                                            "
                                                            [animation]="false"
                                                            (hide)="
                                                                panelChildChange(
                                                                    $event,
                                                                    true
                                                                )
                                                            "
                                                            (show)="
                                                                panelChildChange(
                                                                    $event,
                                                                    false
                                                                )
                                                            "
                                                        >
                                                            @for (
                                                                grandChildForm of firstLevel[
                                                                    $any(
                                                                        elementDefinition.name
                                                                    )
                                                                ].formArray
                                                                    .controls[
                                                                    childFormIndex
                                                                ].controls[
                                                                    childElement
                                                                        .name
                                                                ].controls;
                                                                track $index;
                                                                let grandChildFormIndex = $index
                                                            ) {
                                                                <div
                                                                    ngbAccordionItem
                                                                    class="sub-form"
                                                                    id="ngb-panel-child-{{
                                                                        childElement.name
                                                                    }}-grandchild-{{
                                                                        grandChildFormIndex
                                                                    }}"
                                                                >
                                                                    <div
                                                                        ngbAccordionHeader
                                                                        aria-level="4"
                                                                    >
                                                                        <button
                                                                            ngbAccordionButton
                                                                            type="button"
                                                                            class="accordion-header d-block w-100"
                                                                        >
                                                                            <wdx-ff-accordion-header
                                                                                [entityId]="
                                                                                    entityId
                                                                                "
                                                                                [place]="
                                                                                    grandChildFormIndex
                                                                                "
                                                                                [elementDefinition]="
                                                                                    childElement
                                                                                "
                                                                                [formControlObj]="
                                                                                    grandChildForm
                                                                                "
                                                                                [panelInfo]="
                                                                                    openChildPanels
                                                                                "
                                                                                [hasError]="
                                                                                    $any(
                                                                                        validationSummary?.[
                                                                                            childFormIndex
                                                                                        ]
                                                                                            ?.subsections?.[
                                                                                            grandChildFormIndex
                                                                                        ]
                                                                                    )
                                                                                "
                                                                                (removeItem)="
                                                                                    formArrayService.removeFromArray(
                                                                                        childElement,
                                                                                        {
                                                                                            index: grandChildFormIndex,
                                                                                            parentName:
                                                                                                elementDefinition?.name,
                                                                                            parentIndex:
                                                                                                childFormIndex,
                                                                                        }
                                                                                    )
                                                                                "
                                                                            ></wdx-ff-accordion-header>
                                                                        </button>
                                                                    </div>

                                                                    <div
                                                                        ngbAccordionCollapse
                                                                    >
                                                                        <wdx-ff-sub-form-content
                                                                            ngbAccordionBody
                                                                            #grandChildForm
                                                                            class="d-block accordion-body"
                                                                            [formGroupName]="
                                                                                grandChildFormIndex
                                                                            "
                                                                        >
                                                                            @if (
                                                                                $any(
                                                                                    validationSummary?.[
                                                                                        childFormIndex
                                                                                    ]
                                                                                        ?.subsections?.[
                                                                                        grandChildFormIndex
                                                                                    ]
                                                                                )
                                                                            ) {
                                                                                <wdx-ff-validation-summary
                                                                                    [message]="
                                                                                        VALIDATION_SUMMARY_MESSAGE
                                                                                    "
                                                                                    [validationSummary]="
                                                                                        $any(
                                                                                            validationSummary?.[
                                                                                                childFormIndex
                                                                                            ]
                                                                                                ?.subsections?.[
                                                                                                grandChildFormIndex
                                                                                            ]
                                                                                        )
                                                                                    "
                                                                                    (errorClicked)="
                                                                                        onErrorClicked(
                                                                                            $event,
                                                                                            childFormIndex,
                                                                                            grandChildFormIndex
                                                                                        )
                                                                                    "
                                                                                ></wdx-ff-validation-summary>
                                                                            }

                                                                            @for (
                                                                                grandChildElement of childElement
                                                                                    .children[0]
                                                                                    .layoutAndDefinition;
                                                                                track $index;
                                                                                let grandChildElementIndex = $index
                                                                            ) {
                                                                                @if (
                                                                                    !grandChildElement.isHidden &&
                                                                                    (grandChildElement.elementType ||
                                                                                        grandChildElement.fieldType)
                                                                                ) {
                                                                                    @if (
                                                                                        grandChildElement.forcesNewRow &&
                                                                                        !grandChildElement.forcesFullWidth
                                                                                    ) {
                                                                                        <div
                                                                                            class="g-col-12"
                                                                                        ></div>
                                                                                    }

                                                                                    <div
                                                                                        class="g-col-12 input form-input mb-1"
                                                                                        [class.g-col-lg-6]="
                                                                                            !grandChildElement.forcesFullWidth &&
                                                                                            grandChildElement.fieldType !==
                                                                                                FormFieldType.Address &&
                                                                                            (!grandChildElement.forcesNewRow ||
                                                                                                !grandChildElement.forcesFullWidth)
                                                                                        "
                                                                                        [attr.data-cy]="
                                                                                            'lbl-' +
                                                                                            grandChildElement.name
                                                                                        "
                                                                                        [attr.data-form-control]="
                                                                                            grandChildElement.name
                                                                                        "
                                                                                        [attr.data-form-control-level]="'grandChild'"
                                                                                    >
                                                                                        @if (
                                                                                            grandChildElement.fieldType !==
                                                                                            FormFieldType.Array
                                                                                        ) {
                                                                                            <wdx-ff-controls-container
                                                                                                class="h-100"
                                                                                                [entityId]="
                                                                                                    entityId
                                                                                                "
                                                                                                [formElement]="
                                                                                                    grandChildElement
                                                                                                "
                                                                                                [formContext]="
                                                                                                    formContext
                                                                                                "
                                                                                                [attr.data-cy]="
                                                                                                    'grand-child-element-' +
                                                                                                    grandChildElement.name
                                                                                                "
                                                                                            ></wdx-ff-controls-container>
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            }
                                                                        </wdx-ff-sub-form-content>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            }
                                        }
                                    </wdx-ff-sub-form-content>
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        }
    </ng-container>
}
